 (function () {
   var DESKTOP_QUERY = '(min-width: 768px)';
   var PANEL_SELECTOR = '[data-split-hero] [data-panel-index]';
   var panelRegistry = new WeakMap();
   var trackedPanels = new Set();
  var mediaQuery = window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null;
  var CTA_SELECTOR = '.split-hero__cta';
  var CTA_ACTIVE_CLASS = 'split-hero__cta--active';
  var hoverNoneMediaQuery = window.matchMedia ? window.matchMedia('(hover: none)') : null;
  var ctaObserver = null;
 
   function isDesktop() {
     if (mediaQuery) {
       return mediaQuery.matches;
     }
     return window.innerWidth >= 768;
   }
 
   function parseTargetDate(value) {
     if (!value) {
       return null;
     }
     var normalized = value.trim().replace(' ', 'T');
     var date = new Date(normalized);
     if (isNaN(date.getTime())) {
       return null;
     }
     return date;
   }
 
   function pad(value) {
     return String(value).padStart(2, '0');
   }
 
   function updateTimer(state) {
     if (!state.targetDate) {
       return false;
     }
     var now = Date.now();
     var diff = state.targetDate.getTime() - now;
     if (diff <= 0) {
       state.daysEl.textContent = '00';
       state.hoursEl.textContent = '00';
       state.secondsEl.textContent = '00';
       return false;
     }
     var totalSeconds = Math.floor(diff / 1000);
     var days = Math.floor(totalSeconds / 86400);
     var hours = Math.floor((totalSeconds % 86400) / 3600);
     var seconds = totalSeconds % 60;
     state.daysEl.textContent = pad(days);
     state.hoursEl.textContent = pad(hours);
     state.secondsEl.textContent = pad(seconds);
     return true;
   }
 
   function startInterval(panel, state) {
     if (state.intervalId) {
       return;
     }
     if (!state.daysEl || !state.hoursEl || !state.secondsEl) {
       return;
     }
     if (!updateTimer(state)) {
       return;
     }
     state.intervalId = window.setInterval(function () {
       if (!updateTimer(state)) {
         stopInterval(panel, state);
       }
     }, 1000);
   }
 
  function stopInterval(panel, state) {
    if (state.intervalId) {
      window.clearInterval(state.intervalId);
      state.intervalId = null;
    }
  }

  function getSplitHeroSections(root) {
    var context = root || document;
    if (context instanceof Element && context.hasAttribute('data-split-hero')) {
      return [context];
    }
    if (typeof context.querySelectorAll === 'function') {
      return Array.prototype.slice.call(context.querySelectorAll('[data-split-hero]'));
    }
    return [];
  }

  function initCtaUnderlineActivation(root) {
    if (!hoverNoneMediaQuery || !hoverNoneMediaQuery.matches) {
      return;
    }
    if (typeof window.IntersectionObserver !== 'function') {
      return;
    }
    var sections = getSplitHeroSections(root);
    if (!sections.length) {
      return;
    }
    if (!ctaObserver) {
      ctaObserver = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }
          entry.target.classList.add(CTA_ACTIVE_CLASS);
          if (ctaObserver) {
            ctaObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.4
      });
    }
    sections.forEach(function (section) {
      if (!section.classList.contains('split-hero--underline-enabled')) {
        return;
      }
      var ctas = section.querySelectorAll(CTA_SELECTOR);
      Array.prototype.forEach.call(ctas, function (cta) {
        ctaObserver.observe(cta);
      });
    });
  }

  function teardownCtaUnderlineActivation(root) {
    if (!ctaObserver || !root || typeof root.querySelectorAll !== 'function') {
      return;
    }
    var ctas = root.querySelectorAll(CTA_SELECTOR);
    Array.prototype.forEach.call(ctas, function (cta) {
      ctaObserver.unobserve(cta);
    });
  }

  function syncPanelMode(panel, state) {
    var mode = isDesktop() ? 'desktop' : 'mobile';
    if (state.mode === mode) {
      return;
    }
    state.mode = mode;
    if (mode === 'mobile') {
      startInterval(panel, state);
    } else {
      stopInterval(panel, state);
    }
  }
 
   function registerPanel(panel) {
     if (panelRegistry.has(panel)) {
       return;
     }
     var timerEnabled = panel.getAttribute('data-timer-enabled') === 'true';
     var timerTarget = (panel.getAttribute('data-timer-target') || '').trim();
     var timerEl = panel.querySelector('[data-split-hero-timer]');
     if (!timerEnabled || !timerTarget || !timerEl) {
       return;
     }
 
     var targetDate = parseTargetDate(timerTarget);
     if (!targetDate) {
       return;
     }
 
     var orientation = panel.getAttribute('data-timer-orientation') || 'horizontal';
     var position = panel.getAttribute('data-timer-position') || 'right';
     var animation = panel.getAttribute('data-timer-animation') || 'fade';
 
    timerEl.dataset.orientation = orientation;
    timerEl.dataset.position = position;
    timerEl.dataset.animation = animation;
    timerEl.classList.toggle('split-hero__timer--vertical', orientation === 'vertical');
    timerEl.classList.toggle('split-hero__timer--horizontal', orientation !== 'vertical');

    var state = {
      timerEl: timerEl,
      targetDate: targetDate,
      daysEl: timerEl.querySelector('[data-days]'),
      hoursEl: timerEl.querySelector('[data-hours]'),
      secondsEl: timerEl.querySelector('[data-seconds]'),
      intervalId: null,
      mode: null
    };
 
     function onEnter() {
       if (!isDesktop()) {
         return;
       }
       startInterval(panel, state);
     }
 
     function onLeave() {
       if (!isDesktop()) {
         return;
       }
       stopInterval(panel, state);
     }
 
     panel.addEventListener('mouseenter', onEnter);
     panel.addEventListener('mouseleave', onLeave);
 
     panelRegistry.set(panel, {
       handlers: {
         enter: onEnter,
         leave: onLeave
       },
       state: state
     });
     trackedPanels.add(panel);
     syncPanelMode(panel, state);
   }
 
   function unregisterPanels(root) {
     var context = root || document;
     var panels = context.querySelectorAll(PANEL_SELECTOR);
     panels.forEach(function (panel) {
       var stored = panelRegistry.get(panel);
       if (!stored) {
         return;
       }
        panel.removeEventListener('mouseenter', stored.handlers.enter);
        panel.removeEventListener('mouseleave', stored.handlers.leave);
       stopInterval(panel, stored.state);
       panelRegistry.delete(panel);
       trackedPanels.delete(panel);
     });
   }
 
   function initPanels(root) {
     var context = root || document;
     var panels = context.querySelectorAll(PANEL_SELECTOR);
     panels.forEach(registerPanel);
   }
 
   function refreshPanelModes() {
     trackedPanels.forEach(function (panel) {
       var stored = panelRegistry.get(panel);
       if (stored) {
         syncPanelMode(panel, stored.state);
       }
     });
   }
 
   function handleMediaChange() {
     refreshPanelModes();
   }
 
   function handleResizeFallback() {
     refreshPanelModes();
   }
 
   if (mediaQuery) {
     if (typeof mediaQuery.addEventListener === 'function') {
       mediaQuery.addEventListener('change', handleMediaChange);
     } else if (typeof mediaQuery.addListener === 'function') {
       mediaQuery.addListener(handleMediaChange);
     }
   } else {
     window.addEventListener('resize', handleResizeFallback);
   }
 
  document.addEventListener('DOMContentLoaded', function () {
    initPanels();
    initCtaUnderlineActivation();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initPanels(event.target);
    refreshPanelModes();
    initCtaUnderlineActivation(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unregisterPanels(event.target);
    teardownCtaUnderlineActivation(event.target);
  });
})();
